import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from 'context/AuthContext';

const PortCoGuard = ({ children }: { children: React.ReactNode }) => {
  const { isPortCo, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isPortCo) navigate('/', { replace: true });
  }, [isPortCo, isLoading, navigate]);

  if (!isPortCo) return null;

  return <>{children}</>;
};

export default PortCoGuard;
